import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Helmet from 'react-helmet';
import Snackbar, {
  SnackbarWrapper as SnackbarManager,
} from 'framework-ui-components/Components/Snackbar';
import MenuGeco from 'GeCo';
import { stopLoadingApplication } from 'actions/applicationActions';
import { AppContainer, LoadingPanel } from 'dashboard';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import FwPlugins from 'framework-plugins';
import Assistente from 'Assistente';
import EventoServer from '../../libs/EventoServer';

class LayoutContext extends Component {
  componentDidMount() {
    EventoServer.subscribe(
      'DichiarazioneEliminata',
      this.notificaDichiarazioneEliminata,
    );
    EventoServer.subscribe(
      'DichiarazioneStatoModificato',
      this.notificaDichiarazioneStatoModificato,
    );
    EventoServer.subscribe(
      'DichiarazioneModificaStatoFallita',
      this.notificaDichiarazioneCambioStatoFallito,
    );
    EventoServer.subscribe(
      'OperazioneMassivaCompletata',
      this.notificaOperazioneMassivaCompletata,
    );
    EventoServer.subscribe(
      'DichiarazioneIntegrativaCreata',
      this.notificaDichiarazioneIntegrativaCreata,
    );
    EventoServer.subscribe(
      'DichiarazioneCreata',
      this.notificaDichiarazioneCreata,
    );
    EventoServer.subscribe(
      'StampaDichiarazioneCompletata',
      this.notificaStampaCompletata,
    );
    EventoServer.subscribe(
      'ImportazioneSetteTrentaDaXmlAnnoCorrenteAvviata',
      this.notificaImportazioneDichiarazioneDaXmlAvviata,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaXmlTerminata',
      this.notificaImportazioneDichiarazioneDaXmlTerminata,
    );
    EventoServer.subscribe(
      'CreaSetteTrentaDaXmlAnnoCorrenteFallito',
      this.notificaCreaSetteTrentaDaXmlAnnoCorrenteFallito,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaXmlImportata',
      this.notificaImportazioneDichiarazioneDaXmlImportata,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaXmlCompletata',
      this.notificaImportazioneDichiarazioneDaXmlCompletata,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaXmlNonCompletata',
      this.notificaImportazioneDichiarazioneDaXmlCompletata,
    );
    EventoServer.subscribe(
      'ImportazioneCertificazioniTerminata',
      this.notificaImportazioneCertificazioniTerminata,
    );
    EventoServer.subscribe(
      'ImportazioneSetteTrentaDaRedditiPFAnnoCorrenteAvviata',
      this.notificaImportazioneDichiarazioneDaRedditiPFAvviata,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaRedditiPFTerminata',
      this.notificaImportazioneDichiarazioneDaRedditiPFTerminata,
    );
    EventoServer.subscribe(
      'CreaSetteTrentaDaRedditiPFAnnoCorrenteFallito',
      this.notificaCreaSetteTrentaDaRedditiPFAnnoCorrenteFallito,
    );
    EventoServer.subscribe(
      'ImportazioneDichiarazioneDaRedditiPFImportata',
      this.notificaImportazioneDichiarazioneDaRedditiPFImportata,
    );
    // Eventi di importazione richieste enti
    EventoServer.subscribe(
      'CreazioneMassivaDelegheAvviata',
      this.notificaCreazioneMassivaDelegheAvviata,
    );
    EventoServer.subscribe(
      'CreazioneMassivaDelegheAvanzata',
      this.notificaCreazioneMassivaDelegheAvanzata,
    );
    EventoServer.subscribe(
      'CreazioneMassivaDelegheCompletata',
      this.notificaCreazioneMassivaDelegheCompletata,
    );
    FwPlugins.subscribe(this.pluginsHandler);
  }

  componentWillUnmount() {
    EventoServer.unsubscribe(
      'DichiarazioneEliminata',
      this.notificaDichiarazioneEliminata,
    );
    EventoServer.unsubscribe(
      'DichiarazioneStatoModificato',
      this.notificaDichiarazioneStatoModificato,
    );
    EventoServer.unsubscribe(
      'DichiarazioneModificaStatoFallita',
      this.notificaDichiarazioneCambioStatoFallito,
    );
    EventoServer.unsubscribe(
      'OperazioneMassivaCompletata',
      this.notificaOperazioneMassivaCompletata,
    );
    EventoServer.unsubscribe(
      'DichiarazioneIntegrativaCreata',
      this.notificaDichiarazioneIntegrativaCreata,
    );
    EventoServer.unsubscribe(
      'DichiarazioneCreata',
      this.notificaDichiarazioneCreata,
    );
    EventoServer.unsubscribe(
      'StampaDichiarazioneCompletata',
      this.notificaStampaCompletata,
    );
    EventoServer.unsubscribe(
      'ImportazioneSetteTrentaDaXmlAnnoCorrenteAvviata',
      this.notificaImportazioneDichiarazioneDaXmlAvviata,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaXmlTerminata',
      this.notificaImportazioneDichiarazioneDaXmlTerminata,
    );
    EventoServer.unsubscribe(
      'CreaSetteTrentaDaXmlAnnoCorrenteFallito',
      this.notificaCreaSetteTrentaDaXmlAnnoCorrenteFallito,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaXmlImportata',
      this.notificaImportazioneDichiarazioneDaXmlImportata,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaXmlCompletata',
      this.notificaImportazioneDichiarazioneDaXmlCompletata,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaXmlNonCompletata',
      this.notificaImportazioneDichiarazioneDaXmlCompletata,
    );
    EventoServer.unsubscribe(
      'ImportazioneCertificazioniTerminata',
      this.notificaImportazioneCertificazioniTerminata,
    );
    EventoServer.unsubscribe(
      'ImportazioneSetteTrentaDaRedditiPFAnnoCorrenteAvviata',
      this.notificaImportazioneDichiarazioneDaRedditiPFAvviata,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaRedditiPFTerminata',
      this.notificaImportazioneDichiarazioneDaRedditiPFTerminata,
    );
    EventoServer.unsubscribe(
      'CreaSetteTrentaDaRedditiPFAnnoCorrenteFallito',
      this.notificaCreaSetteTrentaDaRedditiPFAnnoCorrenteFallito,
    );
    EventoServer.unsubscribe(
      'ImportazioneDichiarazioneDaRedditiPFImportata',
      this.notificaImportazioneDichiarazioneDaRedditiPFImportata,
    );
    // Eventi di importazione richieste enti
    EventoServer.unsubscribe(
      'CreazioneMassivaDelegheAvviata',
      this.notificaCreazioneMassivaDelegheAvviata,
    );
    EventoServer.unsubscribe(
      'CreazioneMassivaDelegheAvanzata',
      this.notificaCreazioneMassivaDelegheAvanzata,
    );
    EventoServer.unsubscribe(
      'CreazioneMassivaDelegheCompletata',
      this.notificaCreazioneMassivaDelegheCompletata,
    );
    FwPlugins.unsubscribe(this.pluginsHandler);
  }

  pluginsHandler = ({ type, payload, initial }) => {
    const RITARDO_RIPRISTINO_SERVIZIO_IN_MS = 2000;
    switch (type) {
      case 'assistente_imposta_ufficio':
        Assistente.impostaUfficio(...payload);
        break;
      case 'assistente_imposta_servizio':
        Assistente.impostaServizio(...payload);
        break;
      case 'assistente_apri_permalink':
        Assistente.apriPermalink(...payload);
        break;
      case 'FEEDBACK_OPEN_ASSISTENTE':
        MenuGeco.creaNuovoQuesito();
        break;
      case 'assistente_crea_nuovo_quesito':
        MenuGeco.creaNuovoQuesito(payload);
        break;
      case 'gestione_comunicazioni_crea_nuovo_quesito_su_servizio_specificato':
        const {
          servizioPerCuiCreareQuesito,
          servizioDaRipristinareDopoCreazioneQuesito,
          caricoPaganteCreaNuovoQuesito,
        } = payload;
        MenuGeco.impostaServizioCorrente(servizioPerCuiCreareQuesito);
        MenuGeco.creaNuovoQuesito(caricoPaganteCreaNuovoQuesito);
        setTimeout(() => {
          MenuGeco.impostaServizioCorrente(servizioDaRipristinareDopoCreazioneQuesito);
        }, RITARDO_RIPRISTINO_SERVIZIO_IN_MS);
        break;
      case 'gestione_comunicazioni_imposta_area_selezionata':
        MenuGeco.impostaAreaSelezionata(payload);
        break;
      case 'gestione_comunicazioni_imposta_servizio_corrente':
        MenuGeco.impostaServizioCorrente(payload);
        break;
      case 'call_forward':
        if (payload.type === 'get_root_location') {
          FwPlugins.postMessageToChilds(
            'call_forward_resp',
            { callId: payload.callId, response: { href: window.location.href } },
            initial,
          );
        }
        break;
      default: break;
    }
  };

  notificaCreazioneMassivaDelegheAvviata = (evt) => {
    SnackbarManager.startDeterminateAsyncTask(
      evt.CorrelationId,
      'Importazione Deleghe',
      evt.Totale,
    );
  };

  notificaCreazioneMassivaDelegheAvanzata = (evt) => {
    const operazioneMassiva = Snackbar.recuperaOperazioniMassive().find(
      (x) => x.id == evt.CorrelationId,
    );
    if (operazioneMassiva == null) {
      SnackbarManager.startDeterminateAsyncTask(
        evt.CorrelationId,
        'Importazione Deleghe',
        evt.Totale,
      );
    }
    SnackbarManager.updateDeterminateAsyncTaskProgress(
      evt.CorrelationId,
      evt.Elaborate,
    );
  };

  notificaCreazioneMassivaDelegheCompletata = (evt) => {
    SnackbarManager.completeAsyncTask(evt.CorrelationId);
  };

  notificaImportazioneCertificazioniTerminata = (evt) => {
    SnackbarManager.completeAsyncTask(evt.CorrelationId);
    if (evt.NrCertificazioniInErrore > 0) {
      SnackbarManager.notifyError('Errore in alcune Certificazioni importate.');
    } else {
      SnackbarManager.notifySuccess(
        'Importazione certificazioni avvenuta con successo!',
      );
    }
  };

  notificaDichiarazioneStatoModificato = (evt) => {
    if (evt.Modello === 16 && evt.Anno < 2021) {
      if (
        Snackbar.recuperaOperazioniMassive().find(
          (x) => x.id == evt.CorrelationId,
        )
      ) {
        SnackbarManager.updateDeterminateAsyncTaskProgress(evt.CorrelationId, 1);
      } else {
        this.props.stopLoadingApplication();
        if (evt.Descrizione != null) {
          const msg = `Dichiarazione per ${evt.Descrizione
            } impostata in stato ${StatoDichiarazione.stringify(
              evt.NuovoStato,
              evt.HaErrori,
            )}`;
          SnackbarManager.notifySuccess(msg);
        }
      }
    }
  };

  recuperaUrl(idDichiarazione, anno) {
    const { anniRegistrati } = this.props;
    if (idDichiarazione.startsWith('AssegnoNucleoFamiliare/')) {
      return window.config.urlANF;
    }
    return anniRegistrati.filter((x) => x.Anno == anno)[0].Url730;
  }

  notificaDichiarazioneCreata = (evt) => {
    if (evt.Modello === 16 && evt.Anno < 2021) {
      const { anniRegistrati, annoSelezionato } = this.props;
      const trasmissioniConcluse = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].TrasmissioniConcluse;
      if (evt.ApriDichiarazione === true) {
        const url = this.recuperaUrl(evt.AggregateId, evt.Anno);
        window.location.href = `${url}#/Frontespizio/${evt.AggregateId.split('/')[1]
          }`;
        const msg = `Dichiarazione creata per ${evt.Cognome} ${evt.Nome}`;
        SnackbarManager.notifySuccess(msg);
      } else {
        // provengo da una operazione massiva
        const operazioneMassiva = Snackbar.recuperaOperazioniMassive().find(
          (x) => x.id == `${evt.CorrelationId}ImportXML`,
        );
        if (operazioneMassiva) {
          // l'operazione massiva è utilizzata dall'import xml
          // calcolo inverso del progresso in modo da ricavarmi il record in elaborazione
          const progresso = Math.ceil(
            (operazioneMassiva.progresso / 100) * operazioneMassiva.selezionati,
          ) + 1;
          SnackbarManager.updateDeterminateAsyncTaskProgress(
            `${evt.CorrelationId}ImportXML`,
            progresso,
          );
          if (progresso >= operazioneMassiva.selezionati && !trasmissioniConcluse) {
            SnackbarManager.startDeterminateAsyncTask(
              evt.CorrelationId,
              'Avanza a "Completa"',
              operazioneMassiva.selezionati,
            );
          }
        }
      }
    }
  };

  notificaDichiarazioneIntegrativaCreata = (evt) => {
    if (evt.Modello === 16 && evt.Anno < 2021) {
      const { anniRegistrati } = this.props;
      if (evt.IsDichiarante === true) {
        if (evt.Tipo != 17) {
          const url = anniRegistrati.filter((x) => x.Anno == evt.Anno)[0].Url730;
          window.location.href = `${url}#/Frontespizio/${evt.IdDichiarazione.split('/')[1]
            }`;
        }

        const msg = `Dichiarazione integrativa creata per ${evt.Cognome} ${evt.Nome}`;
        SnackbarManager.notifySuccess(msg);
      }
    }
  };

  notificaDichiarazioneEliminata = (evt) => {
    this.props.stopLoadingApplication();
    if (evt.AzioneAnnullata === false) {
      if (evt.Success === true) {
        if (evt.Descrizione != null
          && (!evt.IdDichiarazione.startsWith('DichiarazioneSetteTrenta') || evt.Anno < 2021)) {
          SnackbarManager.notifySuccess(
            `Dichiarazione ${evt.Descrizione} eliminata.`,
          );
        }
      } else {
        SnackbarManager.notifyError(
          `Errore durante l'eliminazione della dichiarazione ${evt.Descrizione}.`,
        );
      }
    }
  };

  notificaDichiarazioneCambioStatoFallito = (evt) => {
    if (evt.Modello === 16 && evt.Anno < 2021) {
      if (
        Snackbar.recuperaOperazioniMassive().find(
          (x) => x.id == evt.CorrelationId,
        )
      ) {
        SnackbarManager.notifyAsyncTaskError(
          evt.CorrelationId,
          'Cambio stato fallito',
          `${evt.Descrizione} ${evt.DetectedProblems.$values[0]}`,
        );
      } else {
        this.props.stopLoadingApplication();
        if (evt.IdDichiarazione.indexOf('Successione') != -1) {
          evt.DetectedProblems.unshift('Cambio stato fallito. ');
          SnackbarManager.notifyError(evt.DetectedProblems);
        } else if (evt.DetectedProblems) {
          SnackbarManager.notifyError(evt.DetectedProblems.$values);
        } else {
          const msg = `Cambio stato fallito per dichiarazione ${evt.Descrizione}`;
          SnackbarManager.notifyError(msg);
        }
      }
    }
  };

  notificaImportazioneDichiarazioneDaXmlTerminata = (evt) => {
    const { annoSelezionato } = this.props;

    if (annoSelezionato <= 2020) {
      SnackbarManager.completeAsyncTask(
        `${evt.CorrelationId}`,
        evt.TotaleDichiarazioniProcessate,
      );
      SnackbarManager.completeAsyncTask(
        `${evt.CorrelationId}ImportXML`,
        evt.TotaleDichiarazioniProcessate,
        /* 'Download',
        () => {
          if (evt.UrlScaricamento != null) {
            window.open(evt.UrlScaricamento, '_blank');
          }
        }, */
      );
    }
  };

  notificaImportazioneDichiarazioneDaXmlAvviata = (evt) => {
    const { annoSelezionato } = this.props;

    if (annoSelezionato <= 2020) {
      // taccone della modonna. nella stessa dashboard devo notificare l'avanzamento di più wf. separo i due id aggiungendo Import nel primo.
      SnackbarManager.startDeterminateAsyncTask(
        `${evt.CorrelationId}ImportXML`,
        'Importazione XML',
        evt.CodiciFiscaliDaImportare.length
        || evt.CodiciFiscaliDaImportare.$values.length,
      );
    }
  };

  notificaImportazioneDichiarazioneDaRedditiPFTerminata = (evt) => {
    SnackbarManager.completeAsyncTask(
      `${evt.CorrelationId}`,
      evt.TotaleDichiarazioniProcessate,
    );
  };

  notificaImportazioneDichiarazioneDaRedditiPFAvviata = (evt) => {
    SnackbarManager.startDeterminateAsyncTask(
      `${evt.CorrelationId}`,
      'Importazione Redditi PF',
      evt.CodiciFiscaliDaImportare.length
      || evt.CodiciFiscaliDaImportare.$values.length,
    );
  };

  notificaOperazioneMassivaCompletata = (evt) => {
    SnackbarManager.completeAsyncTask(evt.CorrelationId);
  };

  notificaCreaSetteTrentaDaXmlAnnoCorrenteFallito = (evt) => {
    const { annoSelezionato } = this.props;

    if (annoSelezionato <= 2020) {
      SnackbarManager.notifyAsyncTaskError(
        `${evt.CorrelationId}ImportXML`,
        `${evt.CodiceFiscale}: ${evt.Errori}`,
      );
    }
  };

  notificaImportazioneDichiarazioneDaXmlImportata = (evt) => {
    const { anniRegistrati, annoSelezionato } = this.props;
    const trasmissioniConcluse = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].TrasmissioniConcluse;
    const operazioneMassiva = Snackbar.recuperaOperazioniMassive().find(
      (x) => x.id == `${evt.CorrelationId}ImportXML`,
    );
    if (operazioneMassiva && annoSelezionato <= 2020) {
      // calcolo inverso del progresso in modo da ricavarmi il record in elaborazione
      const progresso = Math.ceil(
        (operazioneMassiva.progresso / 100) * operazioneMassiva.selezionati,
      ) + 1;
      SnackbarManager.updateDeterminateAsyncTaskProgress(
        `${evt.CorrelationId}ImportXML`,
        progresso,
      );
      if (progresso >= operazioneMassiva.selezionati && !trasmissioniConcluse) {
        SnackbarManager.startDeterminateAsyncTask(
          evt.CorrelationId,
          'Avanza a "Completa"',
          operazioneMassiva.selezionati,
        );
      }
    }
  };

  notificaImportazioneDichiarazioneDaXmlCompletata = (evt) => {
    const operazioneMassiva = Snackbar.recuperaOperazioniMassive().find(
      (x) => x.id == evt.CorrelationId,
    );
    if (operazioneMassiva) {
      // calcolo inverso del progresso in modo da ricavarmi il record in elaborazione
      const progresso = Math.ceil(
        (operazioneMassiva.progresso / 100) * operazioneMassiva.selezionati,
      ) + 1;
      SnackbarManager.updateDeterminateAsyncTaskProgress(
        evt.CorrelationId,
        progresso,
      );
    }
  };

  notificaCreaSetteTrentaDaRedditiPFAnnoCorrenteFallito = (evt) => {
    SnackbarManager.notifyAsyncTaskError(
      `${evt.CorrelationId}`,
      `${evt.CodiceFiscale}: ${evt.Errori}`,
    );
  };

  notificaImportazioneDichiarazioneDaRedditiPFImportata = (evt) => {
    const operazioneMassiva = Snackbar.recuperaOperazioniMassive().find(
      (x) => x.id == `${evt.CorrelationId}`,
    );
    if (operazioneMassiva) {
      // calcolo inverso del progresso in modo da ricavarmi il record in elaborazione
      const progresso = Math.ceil(
        (operazioneMassiva.progresso / 100) * operazioneMassiva.selezionati,
      ) + 1;
      SnackbarManager.updateDeterminateAsyncTaskProgress(
        `${evt.CorrelationId}`,
        progresso,
      );
    }
  };

  notificaStampaCompletata = (evt) => {
    const { anniRegistrati } = this.props;

    if (evt.Anno < 2020) {
      if (evt.Success) {
        if (evt.Avvisi) {
          SnackbarManager.notifyAsyncTaskError(evt.CorrelationId, evt.Avvisi);
        }
        if (evt.DichiarazioniProcessate == evt.DichiarazioniTotali) {
          SnackbarManager.completeAsyncTask(
            evt.CorrelationId,
            evt.DichiarazioniTotali,
            'Download',
            () => {
              if (evt.UrlScaricamento != null) {
                window.open(evt.UrlScaricamento, '_blank');
              } else {
                const url = anniRegistrati.filter((x) => x.Anno == evt.Anno)[0]
                  .Url730;
                window.open(
                  `${url}api/V1/SetteTrenta${evt.Anno}/ApriFileStampa?fileName=${evt.NomeFile}&codiceUfficio=${evt.CodiceUfficio}`,
                  '_blank',
                );
                Snackbar.clear();
              }
            },
          );
        } else {
          SnackbarManager.updateDeterminateAsyncTaskProgress(
            evt.CorrelationId,
            evt.DichiarazioniProcessate,
          );
        }
      } else {
        SnackbarManager.notifyAsyncTaskError(evt.CorrelationId, evt.Errore);
        SnackbarManager.completeAsyncTask(evt.CorrelationId);
      }
    } else if (evt.Anno < 2021 || Snackbar.recuperaOperazioniMassive().some((x) => x.id === evt.CorrelationId)) {
      SnackbarManager.updateDeterminateAsyncTaskProgress(
        evt.CorrelationId,
        evt.DichiarazioniProcessate,
      );

      if (evt.Errore || evt.Avvisi) {
        SnackbarManager.notifyAsyncTaskError(
          evt.CorrelationId,
          evt.Errore || evt.Avvisi,
        );
      }

      if (evt.DichiarazioniProcessate === evt.DichiarazioniTotali) {
        if (evt.DichiarazioniTotali === 0) {
          SnackbarManager.completeAsyncTask(
            evt.CorrelationId,
            evt.DichiarazioniTotali,
          );
        } else {
          SnackbarManager.completeAsyncTask(
            evt.CorrelationId,
            evt.DichiarazioniTotali,
            'Download',
            () => window.open(evt.UrlScaricamento, '_blank'),
          );
        }
      }
    }
  };

  render() {
    const { children, isLoadingApplication } = this.props;

    return (
      <Fragment>
        <Helmet titleTemplate="Dashboard - %s" />
        <LoadingPanel isLoading={isLoadingApplication}>{children}</LoadingPanel>
        <div id="providerModale" />

        {/* Routing */}
        <Route path="/" component={AppContainer} />
      </Fragment>
    );
  }
}

LayoutContext.propTypes = {
  children: PropTypes.element,
  isLoadingApplication: PropTypes.bool,
  stopLoadingApplication: PropTypes.func,
};

const mapStoreToProps = (store) => ({
  isLoadingApplication: store.application.isLoadingApplication,
  anniRegistrati: store.dichiarativi.anniRegistrati.data,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

const mapDispatchToProps = (dispatch) => ({
  stopLoadingApplication: bindActionCreators(stopLoadingApplication, dispatch),
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps,
)(LayoutContext);
